<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <a-form layout='inline'>
          <a-form-item v-if="canSave">
            <a-button icon="plus" type="primary" @click="showEditModal()">新增供应商</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="search">
        <a-form layout='inline' @submit="searchList">
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>供应商名称</span>
              </template>
              <a-input allowClear v-model.trim="searchData.keywords" placeholder="供应商名称" style="width: 200px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item v-if="canIndex">
            <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="cat_id"
        :columns="columns" :dataSource="list">
          <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>
        <template slot="image" slot-scope="text, record">
          <LImg :src="text" style="width: 66px; height: 66px;"/>
        </template>
          <template slot="action" slot-scope="text,record">
            <a v-if="canUpdate" href="javascript:;" @click="showEditModal(record)">编辑</a>
            <a-divider v-if="canUpdate" type="vertical" />
            <a v-if="canDelete" href="javascript:;" @click="deleteItem(record)">删除</a>
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
    <editModal v-if="editVisible" :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index'},
  { title: '供应商名称', dataIndex: 'suppliers_name', key: 'suppliers_name' },
  { title: '供应商备注', dataIndex: 'suppliers_remark', key: 'suppliers_remark' },
  { title: '进货合计', dataIndex: 'suppliers_amount', key: 'suppliers_amount', align:'center'},
  { title: '库存余量', dataIndex: 'suppliers_stock_amount', key: 'suppliers_stock_amount', align:'center'},
  { title: '供应商电话', dataIndex: 'suppliers_cellphone', key: 'suppliers_cellphone' ,align:'center'},
  { title: '供应商地址', dataIndex: 'suppliers_address', key: 'suppliers_address' ,align:'center' },
  { title: '供应商状态', dataIndex: 'suppliers_status', key: 'suppliers_status' ,align:'center'},
  { title: '添加时间', dataIndex: 'created_at', key: 'created_at' },
  { title: '操作账户', dataIndex: 'created_by', key: 'created_by' ,align:'center'},
  { title: '操作', key: 'operation', width: 100, fixed: 'right', scopedSlots: { customRender: 'action' }},
]

import C_ITEMS from '@/utils/items'
import editModal from './editModal'
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'
export default {
  name: 'gjjl',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
  },

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,
      productStatus: C_ITEMS.productStatus,
      productCom: C_ITEMS.productCom,
      searchData: {},
      visible: false,
      modalData: {},
      editVisible: false,
      authType:['market','store'],
    }
  },
  mixins: [ authority, tableMixins ],

  methods: {
    closeSearch() {
      this.visible = false
    },
    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          obj[k] = searchData[k]
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('storeSuppliersAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    showEditModal(item) {
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },
    deleteItem(item) {
      let that = this
      this.$confirm({
        title: `您确定要删除"${item.suppliers_name}"吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('storeSuppliersDeleteAction', { data: { suppliers_id: item.suppliers_id } })
            if (res) {
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
  }
}
</script>
